import React from 'react';
import { MeetingType } from '../../../model';
import { ReactComponent as GoogleIcon } from './google.svg';
import { ReactComponent as JitsiIcon } from './jitsi.svg';
import { ReactComponent as TeamsIcon } from './teams.svg';
import { ReactComponent as WebExIcon } from './webex.svg';
import { ReactComponent as ZoomIcon } from './zoom.svg';
import { ReactComponent as IpfxIcon } from './ipfx.svg';

export { GoogleIcon, JitsiIcon, TeamsIcon, WebExIcon, ZoomIcon, IpfxIcon };

type SvgProps = React.SVGProps<SVGSVGElement> & { title?: string }

export function MeetingTypeIcon({ type, ...rest }: { type: MeetingType } & SvgProps) {
   return React.createElement(getMeetingTypeIcon(type), rest)
}

function getMeetingTypeIcon(type: MeetingType) {
   switch (type) {
      case 'GoogleMeet': return GoogleIcon
      case 'Jitsi': return JitsiIcon
      case 'Teams': return TeamsIcon
      case 'WebEx': return WebExIcon
      case 'Zoom': return ZoomIcon
      case 'Ipfx': return IpfxIcon
   }

   const _exhaustive: never = type
}

export function getMeetingTypeTitle(type: MeetingType) {
   switch (type) {
      case 'GoogleMeet': return 'Google'
      case 'Jitsi': return 'Jitsi'
      case 'Teams': return 'MS Teams'
      case 'WebEx': return 'WebEx'
      case 'Zoom': return 'Zoom'
      case 'Ipfx': return 'IPFX'
   }

   const _exhaustive: never = type
}
